module.exports = __webpack_public_path__ + "static/media/make-private.ea94e275.svg";